import { useTranslation } from "react-i18next";
import { useOperationsMap } from "../OperationsMapProvider";
import { Alert, AlertTitle, Box, Button, Skeleton, Stack } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { HeatmapLayerSettings } from "../map/plugins/HeatmapLayer";
import { TrafficLayerSettings } from "../map/plugins/TrafficWarnings";
import { VehiclesLayerSettings } from "../map/plugins/VehiclesLayer";
import { WeatherLayerSettings } from "../map/plugins/WeatherLayer";
import { MyLocationsLayerSettings } from "../map/plugins/MyLocationsLayer";
import { DispatchLayerSettings } from "../map/plugins/DispatchLayer";
import { Cached as CachedIcon } from "@mui/icons-material"

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      marginLeft: `calc(var(--scrollbar-width) * -1)`,
      marginRight: `calc(var(--scrollbar-width) * -1)`,
    },
    alertContainer: {
      padding: theme.spacing(2)
    },
    link: {
      textDecoration: "none",
      color: "inherit",
      whiteSpace: "nowrap"
    },
    resetButtonBox: {
      width: "100%",
      justifyContent: "center",
      display: "flex",
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(0)
    },
    skeleton: {
      margin: theme.spacing(1),
      marginBottom: 0,
      width: `calc(100% - ${theme.spacing(2)})`
    }
  })
);

export default function LayerSettingsPanel() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { operationsMap, resetSettings, loaded } = useOperationsMap();

  return !!operationsMap ? (
    <Stack className={classes.root}>
      {
        loaded ? (
          <>
            <DispatchLayerSettings />

            <VehiclesLayerSettings />

            <MyLocationsLayerSettings />

            <TrafficLayerSettings />

            <HeatmapLayerSettings />

            <WeatherLayerSettings />

            <Box className={classes.resetButtonBox}>
              <Button onClick={resetSettings} color="neutral" variant="contained" startIcon={<CachedIcon />}>
                {t("operationsMap:resetSettings")}
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Skeleton className={classes.skeleton} variant="rounded" height="220px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="160px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="240px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="40px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="40px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="40px" />
          </>
        )
      }



      <Box className={classes.alertContainer}>
        <Alert
          severity="info"
          action={
            <a href="https://www.notion.so/getassist/1bae3afe5b388038bf21ffa008ae19ec" target="_blank" className={classes.link}>
              <Button color="inherit" size="small">
                Del feedback
              </Button>
            </a>
          }
        >
          <AlertTitle>Test det nye kartet!</AlertTitle>
          Dette er første versjon - prøv den ut og si hva du mener. Din tilbakemelding er viktig for å gjøre kartet best mulig!
        </Alert>
      </Box>

    </Stack>
  ) : null;
}

